import React, { useState, useEffect, useContext } from 'react';
import { 
  Button, 
  Alert, 
  Box, 
  Grid, 
  Typography, 
  CircularProgress,
  Card,
  CardContent,
  CardActions,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Tooltip,
  FormControlLabel,
  Checkbox,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import { 
  obtenerCuadrantes, 
  obtenerCuadrantesPersona, 
  obtenerTodosCuadrantes, 
  obtenerCuadrantesFreematica,
  obtenerTurnosCuadrantes,
  obtenerTurnosCuadrantesInteligente,
  obtenerTurnosPersona,
  obtenerTurnosServicio,
  calcularHorasTurno,
  diagnosticarTurnosIndividuales,
  buscarDatosHistoricos,
  guardarTurnosEnBD,
  pushTurnosAFreematica,
  guardarTurnosYPushAFreematica,
  buscarServicioFreematica,
  extraerDatosLocalizacion
} from '../services/ApiMarcajes';
import { obtenerVigilantesPorServicio, obtenerDetallesServicio, obtenerEmpresas, agregarTurno, createCuadrante } from '../data/FirestoreCuadrantes';
import { AuthContext } from '../../../context/AuthContext';
import { db } from '../../../firebase';
import { collection, doc, addDoc, getDocs, query, where } from 'firebase/firestore';

const FreematicaTramos = ({ currentService, servicioId, onClose }) => {
  const { currentUser } = useContext(AuthContext) || {};
  
  console.log('🔍 FreematicaTramos - currentUser:', currentUser);
  console.log('🔍 FreematicaTramos - currentService:', currentService);
  console.log('🔍 FreematicaTramos - servicioId:', servicioId);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tramosData, setTramosData] = useState({});
  const [vigilantes, setVigilantes] = useState([]);
  const [detallesServicio, setDetallesServicio] = useState(null);
  const [expandedVigilante, setExpandedVigilante] = useState(null);
  
  // Estados para selección de empresa
  const [empresas, setEmpresas] = useState([]);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState('');
  const [personaSeleccionada, setPersonaSeleccionada] = useState('');
  const [endpointConstruido, setEndpointConstruido] = useState('');
  const [probandoEndpoint, setProbandoEndpoint] = useState(false);

  // Estados para turnos individuales
  const [turnosIndividuales, setTurnosIndividuales] = useState({});
  const [expandedMeses, setExpandedMeses] = useState({});
  const [expandedDias, setExpandedDias] = useState({});
  const [cargandoTurnos, setCargandoTurnos] = useState(false);
  const [cargandoTurnosIndividuales, setCargandoTurnosIndividuales] = useState({});
  const [filtrosTurnos, setFiltrosTurnos] = useState({
    año: new Date().getFullYear().toString(),
    mes: '',
    dia: '',
    codPersona: ''
  });
  const [turnosPorMes, setTurnosPorMes] = useState({});

  // Cargar datos iniciales
  useEffect(() => {
    const cargarDatosIniciales = async () => {
      try {
        console.log('🚀 Iniciando carga de datos iniciales...');
        console.log('📋 Parámetros:', { currentService, servicioId });
        
        setLoading(true);
        setError('');

        // Cargar empresas desde Firestore
        console.log('🔍 Cargando empresas desde Firestore...');
        const empresasData = await obtenerEmpresas(currentService);
        console.log('📋 Empresas cargadas:', empresasData);
        setEmpresas(empresasData);

        // Cargar detalles del servicio
        const servicioIdToUse = Array.isArray(servicioId) ? servicioId[0] : servicioId;
        console.log('🔍 ServicioId a usar:', servicioIdToUse);
        
        if (servicioIdToUse) {
          const detalles = await obtenerDetallesServicio(servicioIdToUse, currentService);
          console.log('📋 Detalles del servicio cargados:', detalles);
          setDetallesServicio(detalles);
        } else {
          console.warn('⚠️ No hay servicioId disponible');
        }

        // Cargar vigilantes del servicio
        if (currentService) {
          console.log('🔍 Cargando vigilantes del servicio...');
          const vigilantesData = await obtenerVigilantesPorServicio(servicioIdToUse, currentService);
          console.log('👥 Vigilantes cargados:', vigilantesData);
          setVigilantes(vigilantesData || []);
        } else {
          console.warn('⚠️ No hay currentService disponible');
        }
        
        console.log('✅ Carga de datos iniciales completada');
      } catch (error) {
        console.error('❌ Error cargando datos iniciales:', error);
        setError('Error cargando datos iniciales: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    cargarDatosIniciales();
  }, [currentService, servicioId]);

  // Función para obtener todas las personas disponibles del servicio
  const obtenerPersonasDisponibles = () => {
    try {
      console.log('🔍 Obteniendo todas las personas del servicio');
      
      // Validar que vigilantes sea un array válido
      if (!vigilantes || !Array.isArray(vigilantes)) {
        console.warn('⚠️ vigilantes no es un array válido:', vigilantes);
        return [];
      }
      
      // Usar todos los vigilantes del servicio que tengan código de persona
      const personas = vigilantes.filter(vigilante => 
        vigilante && vigilante.persona && vigilante.persona.trim() !== ''
      );
      
      console.log('👥 Personas disponibles del servicio:', personas);
      return personas;
      
    } catch (error) {
      console.error('Error obteniendo personas del servicio:', error);
      return [];
    }
  };

  // Manejar cambio de empresa seleccionada
  const handleEmpresaChange = (event) => {
    const empresaId = event.target.value;
    console.log('🏢 Empresa seleccionada:', empresaId);
    setEmpresaSeleccionada(empresaId);
    setPersonaSeleccionada(''); // Resetear persona seleccionada
  };

  // Manejar cambio de persona seleccionada
  const handlePersonaChange = (event) => {
    const personaId = event.target.value;
    console.log('👤 Persona seleccionada:', personaId);
    setPersonaSeleccionada(personaId);
  };

  // Función para probar el endpoint directamente
  const probarEndpoint = async () => {
    if (!endpointConstruido) {
      setError('No hay endpoint construido para probar');
      return;
    }

    try {
      setProbandoEndpoint(true);
      setError('');

      console.log('🧪 Probando endpoint directamente:', endpointConstruido);

      // Hacer la petición directamente
      const response = await fetch(endpointConstruido, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': '6075893bb0224601a40f5e9fd1723864',
          'x-auth-app': '87452890|6484502060e844cdba2cc6d5ab8c02a2',
          'x-auth-organization': '0109',
          'x-auth-company': '0001',
          'x-auth-session': '6075893bb0224601a40f5e9fd1723864'
        }
      });

      const data = await response.json();
      
      console.log('✅ Respuesta del endpoint:', data);
      
      if (response.ok) {
        alert(`✅ Endpoint funcionando correctamente!\n\nRespuesta: ${JSON.stringify(data, null, 2)}`);
      } else {
        alert(`❌ Error en el endpoint (${response.status}):\n\n${JSON.stringify(data, null, 2)}`);
      }
    } catch (error) {
      console.error('❌ Error probando endpoint:', error);
      alert(`❌ Error probando endpoint:\n\n${error.message}`);
    } finally {
      setProbandoEndpoint(false);
    }
  };

  // Función para obtener cuadrantes de Freematica
  const obtenerCuadrantesFreematicaHandler = async () => {
    try {
      setLoading(true);
      setError('');

      console.log('🚀 Iniciando obtención de cuadrantes de Freematica...');
      
      // Validar que se haya seleccionado una empresa
      if (!empresaSeleccionada) {
        throw new Error('Debe seleccionar una empresa');
      }

      // Obtener datos de la empresa seleccionada
      const empresa = empresas.find(emp => emp.id === empresaSeleccionada);
      if (!empresa) {
        throw new Error('Empresa no encontrada');
      }

      console.log('🏢 Datos de la empresa seleccionada:', empresa);

      // Obtener personas disponibles del servicio
      console.log('🔍 Estado actual:', {
        vigilantes: vigilantes,
        empresaSeleccionada: empresaSeleccionada,
        personaSeleccionada: personaSeleccionada
      });
      
      const personasDisponibles = obtenerPersonasDisponibles();
      
      // Validar que personasDisponibles sea un array válido
      if (!personasDisponibles || !Array.isArray(personasDisponibles)) {
        console.error('❌ personasDisponibles no es un array válido:', personasDisponibles);
        throw new Error('Error al obtener personas del servicio');
      }
      
      console.log('👥 Personas disponibles del servicio:', personasDisponibles);
      
      // Determinar personas a consultar
      let personas = [];
      if (personaSeleccionada && personaSeleccionada.trim() !== '') {
        // Si se seleccionó una persona específica, usar solo esa
        personas = [personaSeleccionada];
        console.log('👤 Usando persona específica:', personaSeleccionada);
      } else {
        // Si no se seleccionó persona específica, usar todas las personas del servicio
        personas = personasDisponibles
          .filter(vigilante => vigilante.persona && vigilante.persona.trim() !== '')
          .map(vigilante => vigilante.persona);
        console.log('👥 Usando todas las personas del servicio:', personas);
      }

      if (!personas || personas.length === 0) {
        throw new Error('No hay personas disponibles para consultar');
      }

      // Obtener el año actual
      const añoActual = new Date().getFullYear().toString();
      
      // Construir endpoint y parámetros
      const codEmpresa = empresa.codEmpresa || '0001';
      const delegacion = '06'; // Valor por defecto
      
      // Extraer servicio de la localización
      let servicio = '03';
      
      if (detallesServicio?.localizacion) {
        try {
          const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
          servicio = datosLocalizacion.servicio;
          console.log('🔍 Datos extraídos de localización:', datosLocalizacion);
        } catch (error) {
          console.warn('⚠️ Error extrayendo datos de localización, usando valores por defecto:', error.message);
        }
      }
      
      console.log('🔗 Construyendo endpoint con parámetros:', {
        año: añoActual,
        empresa: codEmpresa,
        delegacion: delegacion,
        servicio: servicio,
        personas: personas,
        empresaSeleccionada: empresa.nombre,
        codEmpresa: codEmpresa,
        localizacionOriginal: detallesServicio?.localizacion
      });
      
      // Construir URL del endpoint correcta
      const baseUrl = 'https://api-p02.clientservicepanel.com/restsat/api/pvss/v1/cuadrantes';
      
      // Construir rquery con múltiples condiciones para personas
      let rquery = `CUADT_CAL==${añoActual}`;
      
      // Agregar condiciones para cada persona
      if (personas.length === 1) {
        rquery += `;CUADT_PERSONA==${personas[0]}`;
      } else if (personas.length > 1) {
        // Para múltiples personas, usar OR lógico
        const personasQuery = personas.map(p => `CUADT_PERSONA==${p}`).join(';');
        rquery += `;${personasQuery}`;
      }
      
      // Agregar filtro de servicio
      rquery += `;CUADT_SERV==${servicio}`;
      
      const endpoint = `${baseUrl}?rquery=${rquery}`;
      
      // Guardar el endpoint construido para mostrarlo en la UI
      setEndpointConstruido(endpoint);
      
      console.log('🌐 Endpoint construido:', endpoint);
      console.log('🔍 Rquery construido:', rquery);
      console.log('📊 Datos de la empresa para la consulta:', {
        nombre: empresa.nombre,
        codEmpresa: codEmpresa,
        delegacion: delegacion,
        servicio: servicio,
        personas: personas
      });
      
      // Mostrar curl equivalente para debugging
      const curlCommand = `curl -X GET "${endpoint}" -H "Content-Type: application/json"`;
      console.log('🔧 Comando curl equivalente:', curlCommand);
      
      // Mostrar ejemplo de endpoint esperado
      const ejemploEndpoint = `https://api-p02.clientservicepanel.com/restsat/api/pvss/v1/cuadrantes?rquery=CUADT_CAL==2025;CUADT_PERSONA==17005;CUADT_CTRT==15241;CUADT_SERV==03`;
      console.log('📋 Ejemplo de endpoint esperado:', ejemploEndpoint);
      
      // Obtener cuadrantes de Freematica
      const cuadrantes = await obtenerCuadrantesFreematica(añoActual, personas, servicio);
      
      console.log('🟢 DATA CRUDA DEL ENDPOINT:', cuadrantes);
      console.log('📊 Respuesta de la API:', cuadrantes);
      console.log('📊 Tipo de respuesta:', typeof cuadrantes);
      console.log('📊 Es array?', Array.isArray(cuadrantes));
      
      // Validar que cuadrantes sea un array
      if (!cuadrantes || !Array.isArray(cuadrantes)) {
        console.warn('⚠️ La respuesta no es un array válido:', cuadrantes);
        setTramosData({});
        setError('La respuesta de la API no es válida. Verifica los parámetros del endpoint.');
        return;
      }
      
      if (cuadrantes.length === 0) {
        console.log('⚠️ No se encontraron cuadrantes para los vigilantes');
        setTramosData({});
        return;
      }
      
      console.log(`✅ Se encontraron ${cuadrantes.length} cuadrantes`);
      
      // Procesar y formatear los datos para mostrar
      const cuadrantesPorVigilante = {};
      
      cuadrantes.forEach(cuadrante => {
        const codPersona = cuadrante.CUADT_PERSONA;
        const mes = cuadrante.CUADT_MES;
        
        // Buscar el vigilante correspondiente
        const vigilante = personasDisponibles.find(v => v.persona === codPersona);
        
        // Inicializar el vigilante si no existe
        if (!cuadrantesPorVigilante[codPersona]) {
          if (vigilante) {
            cuadrantesPorVigilante[codPersona] = {
              vigilante: vigilante,
              cuadrantes: {} // Objeto para almacenar cuadrantes por mes
            };
          } else {
            // Si no se encuentra el vigilante, crear uno ficticio con los datos del cuadrante
            cuadrantesPorVigilante[codPersona] = {
              vigilante: {
                nombre: cuadrante.VSSPER_NOM || 'N/A',
                apellidos: `${cuadrante.VSSPER_APELL1 || ''} ${cuadrante.VSSPER_APELL2 || ''}`.trim(),
                persona: codPersona
              },
              cuadrantes: {} // Objeto para almacenar cuadrantes por mes
            };
          }
        }
        
        // Agregar el cuadrante al mes correspondiente
        cuadrantesPorVigilante[codPersona].cuadrantes[mes] = cuadrante;
      });
      
      console.log('📊 Cuadrantes procesados por vigilante y mes:', cuadrantesPorVigilante);
      
      setTramosData(cuadrantesPorVigilante);
      console.log('📊 Cuadrantes procesados:', cuadrantesPorVigilante);
    } catch (error) {
      console.error('❌ Error obteniendo cuadrantes:', error);
      setError('Error obteniendo cuadrantes: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Función para formatear fecha
  const formatearFecha = (fecha) => {
    if (!fecha) return 'N/A';
    try {
      return new Date(fecha).toLocaleDateString('es-ES');
    } catch {
      return fecha;
    }
  };

  // Función para formatear hora
  const formatearHora = (hora) => {
    if (!hora) return 'N/A';
    return hora;
  };

  // Función para obtener el nombre del mes
  const getMonthName = (mes) => {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return meses[parseInt(mes) - 1] || 'Mes ' + mes;
  };

  // Función para extraer datos de localización
  const extraerDatosLocalizacion = (localizacion) => {
    if (!localizacion) {
      throw new Error('El valor de localización es inválido');
    }
    
    console.log(`🔍 Extrayendo datos de localización: "${localizacion}"`);
    
    // Limpiar espacios y asegurar formato
    const localizacionLimpia = localizacion.trim();
    console.log(`🔍 Localización limpia: "${localizacionLimpia}"`);
    
    // El formato es "CONTRATO/SERVICIO" (XXXX/XX)
    const partes = localizacionLimpia.split('/');
    console.log(`🔍 Partes encontradas:`, partes);
    
    if (partes.length < 2) {
      throw new Error(`El formato de localización debe ser "CONTRATO/SERVICIO" (XXXX/XX). Valor recibido: "${localizacion}"`);
    }
    
    // Asegurar que las partes estén limpias y sean strings
    const contrato = partes[0].trim();
    const servicio = partes[1].trim();
    
    console.log(`🔍 Contrato extraído: "${contrato}"`);
    console.log(`🔍 Servicio extraído: "${servicio}"`);
    
    const resultado = {
      contrato: contrato,     // Primer valor es contrato (XXXX)
      servicio: servicio      // Segundo valor es servicio (XX)
    };
    
    console.log("✅ Datos extraídos:", resultado);
    return resultado;
  };

  // Función para calcular duración
  const calcularDuracion = (horaInicio, horaFin) => {
    if (!horaInicio || !horaFin) return 'N/A';
    
    try {
      const [horaIni, minIni] = horaInicio.split(':').map(Number);
      const [horaFinNum, minFin] = horaFin.split(':').map(Number);
      
      let minutosInicio = horaIni * 60 + minIni;
      let minutosFin = horaFinNum * 60 + minFin;
      
      // Si la hora de fin es menor que la de inicio, es turno nocturno
      if (minutosFin < minutosInicio) {
        minutosFin += 24 * 60; // Añadir 24 horas
      }
      
      const duracionMinutos = minutosFin - minutosInicio;
      const horas = Math.floor(duracionMinutos / 60);
      const minutos = duracionMinutos % 60;
      
      return `${horas}h ${minutos}min`;
    } catch {
      return 'N/A';
    }
  };

  // Funciones para turnos individuales
  const cargarTurnosIndividuales = async (codPersona = null) => {
    if (!detallesServicio) {
      setError('No hay detalles de servicio disponibles');
      return;
    }

    try {
      setCargandoTurnos(true);
      setError('');

      const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
      const empresa = datosLocalizacion.empresa || '0001';
      const delegacion = detallesServicio.delegacion || '06';
      let contrato = datosLocalizacion.contrato;
      const servicio = datosLocalizacion.servicio;

      // Usar la persona seleccionada o la del filtro
      const personaAConsultar = codPersona || filtrosTurnos.codPersona;

      console.log('🔍 Cargando turnos individuales...', {
        empresa,
        delegacion,
        contrato,
        servicio,
        persona: personaAConsultar,
        filtros: filtrosTurnos
      });
      
      console.log('🔍 DETALLES DEL SERVICIO:', {
        localizacion: detallesServicio.localizacion,
        delegacion: detallesServicio.delegacion,
        datosExtraidos: datosLocalizacion
      });
      
      // Verificar si el contrato es correcto
      const contratoCorrecto = '15241';
      const contratoActual = contrato;
      console.log('🔍 COMPARACIÓN DE CONTRATOS:', {
        contratoActual: contratoActual,
        contratoCorrecto: contratoCorrecto,
        sonIguales: contratoActual === contratoCorrecto,
        tipoContratoActual: typeof contratoActual,
        tipoContratoCorrecto: typeof contratoCorrecto
      });
      
      // Si el contrato es incorrecto, usar el correcto
      if (contratoActual !== contratoCorrecto) {
        console.log('⚠️ CONTRATO INCORRECTO DETECTADO!');
        console.log(`❌ Usando: ${contratoActual} (incorrecto)`);
        console.log(`✅ Debería usar: ${contratoCorrecto} (correcto)`);
        console.log('🔄 Usando contrato correcto para la consulta...');
        contrato = contratoCorrecto;
      }

      const turnos = await obtenerTurnosCuadrantesInteligente(
        empresa,
        delegacion,
        contrato,
        servicio,
        parseInt(filtrosTurnos.año),
        filtrosTurnos.mes || null,
        filtrosTurnos.dia || null,
        personaAConsultar || null
      );

      // Organizar turnos por mes y día
      const turnosOrganizados = {};
      turnos.forEach(turno => {
        const mes = turno.mes;
        const dia = turno.dia;
        
        if (!turnosOrganizados[mes]) {
          turnosOrganizados[mes] = {};
        }
        
        if (!turnosOrganizados[mes][dia]) {
          turnosOrganizados[mes][dia] = [];
        }
        
        turnosOrganizados[mes][dia].push(turno);
      });

      setTurnosIndividuales(turnosOrganizados);
      console.log('✅ Turnos individuales cargados:', turnosOrganizados);
    } catch (error) {
      console.error('❌ Error cargando turnos individuales:', error);
      setError('Error cargando turnos individuales: ' + error.message);
    } finally {
      setCargandoTurnos(false);
    }
  };

  const cargarTurnosPorMes = async (codPersona, mes) => {
    if (!detallesServicio || !codPersona || !mes) return;

    // Activar loading específico para esta persona y mes
    setCargandoTurnosIndividuales(prev => ({
      ...prev,
      [`${codPersona}-${mes}`]: true
    }));

    try {
      const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
      const empresa = datosLocalizacion.empresa || '0001';
      const delegacion = detallesServicio.delegacion || '06';
      let contrato = datosLocalizacion.contrato;
      const servicio = datosLocalizacion.servicio;

      console.log(`🔍 Cargando turnos para persona ${codPersona} en mes ${mes}...`);
      
      // Verificar si el contrato es correcto
      const contratoCorrecto = '15241';
      const contratoActual = contrato;
      console.log('🔍 COMPARACIÓN DE CONTRATOS (por mes):', {
        contratoActual: contratoActual,
        contratoCorrecto: contratoCorrecto,
        sonIguales: contratoActual === contratoCorrecto
      });
      
      // Si el contrato es incorrecto, usar el correcto
      if (contratoActual !== contratoCorrecto) {
        console.log('⚠️ CONTRATO INCORRECTO DETECTADO (por mes)!');
        console.log(`❌ Usando: ${contratoActual} (incorrecto)`);
        console.log(`✅ Debería usar: ${contratoCorrecto} (correcto)`);
        console.log('🔄 Usando contrato correcto para la consulta...');
        contrato = contratoCorrecto;
      }

      // Primero ejecutar diagnóstico
      const diagnostico = await diagnosticarTurnosIndividuales(
        empresa,
        delegacion,
        contrato,
        servicio,
        filtrosTurnos.año,
        mes,
        codPersona
      );

      // Si el diagnóstico muestra que hay datos, continuar con la función normal
      if (diagnostico.cuadrantes.items.length > 0 && diagnostico.detalles.items.length > 0) {
        const turnos = await obtenerTurnosCuadrantesInteligente(
          empresa,
          delegacion,
          contrato,
          servicio,
          parseInt(filtrosTurnos.año),
          mes,
          null,
          codPersona
        );

        // Organizar turnos por día
        const turnosPorDia = {};
        turnos.forEach(turno => {
          const dia = turno.dia;
          if (!turnosPorDia[dia]) {
            turnosPorDia[dia] = [];
          }
          turnosPorDia[dia].push(turno);
        });

        setTurnosPorMes(prev => ({
          ...prev,
          [`${codPersona}-${mes}`]: turnosPorDia
        }));

        console.log(`✅ Turnos cargados para mes ${mes}:`, turnosPorDia);
      } else {
        console.log(`⚠️ No se encontraron datos suficientes para mes ${mes}:`, diagnostico.conclusion);
        // Mostrar mensaje de error en la UI
        const vigilante = vigilantes.find(v => v.persona === codPersona);
        const nombreVigilante = vigilante ? `${vigilante.nombre} ${vigilante.apellidos}` : `persona ${codPersona}`;
        setError(`No se encontraron turnos individuales para ${nombreVigilante} en el mes ${mes}. ${diagnostico.conclusion}`);
      }
    } catch (error) {
      console.error(`❌ Error cargando turnos para mes ${mes}:`, error);
      setError(`Error cargando turnos: ${error.message}`);
    } finally {
      // Desactivar loading específico para esta persona y mes
      setCargandoTurnosIndividuales(prev => ({
        ...prev,
        [`${codPersona}-${mes}`]: false
      }));
    }
  };



  const guardarTurnosEnSentry = async (codPersona) => {
    if (!detallesServicio || !codPersona) return;

    try {
      console.log(`💾 Guardando turnos en Sentry para persona ${codPersona}...`);
      
      const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
      const empresa = datosLocalizacion.empresa || '0001';
      const delegacion = detallesServicio.delegacion || '06';
      let contrato = datosLocalizacion.contrato;
      const servicio = datosLocalizacion.servicio;

      // Verificar si el contrato es correcto
      const contratoCorrecto = '15241';
      if (contrato !== contratoCorrecto) {
        console.log('🔄 Usando contrato correcto para guardar en Sentry...');
        contrato = contratoCorrecto;
      }

      // Obtener todos los turnos del año actual
      const turnos = await obtenerTurnosCuadrantesInteligente(
        empresa,
        delegacion,
        contrato,
        servicio,
        parseInt(filtrosTurnos.año),
        null, // sin filtro de mes
        null, // sin filtro de día
        codPersona
      );

      if (!turnos || turnos.length === 0) {
        const vigilante = vigilantes.find(v => v.persona === codPersona);
        const nombreVigilante = vigilante ? `${vigilante.nombre} ${vigilante.apellidos}` : `persona ${codPersona}`;
        setError(`❌ No hay turnos para guardar de ${nombreVigilante} en el año ${filtrosTurnos.año}`);
        return;
      }

      console.log(`📊 Guardando ${turnos.length} turnos en Sentry...`);

      // Obtener el servicioId correcto
      const servicioIdToUse = Array.isArray(servicioId) ? servicioId[0] : servicioId;
      
      // Obtener o crear el cuadranteId
      const userId = currentUser?.uid || 'system';
      const cuadranteId = await createCuadrante(servicioIdToUse, currentService, servicioIdToUse, userId);
      
      console.log('🔍 Cuadrante ID:', cuadranteId);
      
      // Preparar los turnos para guardar en Sentry
      const turnosParaSentry = [];
      for (const turno of turnos) {
        try {
          console.log('🔍 Procesando turno:', turno);
          
          // Convertir el formato del turno para que sea compatible con agregarTurno
          const turnoData = {
            vigilante: String(turno.codigoPersona), // Convertir a string
            fecha: `${turno.año}-${String(turno.mes).padStart(2, '0')}-${String(turno.dia).padStart(2, '0')}`,
            inicioTurno: turno.horaInicio,
            finTurno: turno.horaFin,
            horasTotales: turno.horasTotales,
            empresa: turno.empresa,
            delegacion: turno.delegacion,
            contrato: turno.contrato,
            servicio: turno.servicio,
            turnoOper: turno.turnoOper,
            nombrePersona: turno.nombrePersona,
            apellido1: turno.apellido1,
            apellido2: turno.apellido2,
            nif: turno.nif,
            origen: 'freematica',
            observaciones: 'Turno importado desde Freematica',
            servicioId: servicioIdToUse
          };
          
          console.log('📋 TurnoData a guardar:', turnoData);
          turnosParaSentry.push(turnoData);
          
        } catch (error) {
          console.error('❌ Error procesando turno individual:', error);
        }
      }
      
      // Guardar en Sentry
      const resultadosSentry = [];
      for (const turnoData of turnosParaSentry) {
        try {
          // Guardar directamente en Firestore sin intentar registrar en Freematica
          const cuadranteRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId);
          const turnoRef = await addDoc(collection(cuadranteRef, 'turnos'), turnoData);
          
          console.log('✅ Turno guardado exitosamente en Sentry con ID:', turnoRef.id);
          resultadosSentry.push({ turnoId: turnoRef.id, turno: turnoData, success: true });
          
        } catch (error) {
          console.error('❌ Error guardando turno individual en Sentry:', error);
          resultadosSentry.push({ turno: turnoData, error: error.message, success: false });
        }
      }
      
      const exitososSentry = resultadosSentry.filter(r => r.success).length;
      const fallidosSentry = resultadosSentry.filter(r => !r.success).length;
      
      // Obtener los errores específicos
      const errores = resultadosSentry.filter(r => !r.success).map(r => r.error);
      const erroresUnicos = [...new Set(errores)];

      const vigilante = vigilantes.find(v => v.persona === codPersona);
      const nombreVigilante = vigilante ? `${vigilante.nombre} ${vigilante.apellidos}` : `persona ${codPersona}`;
      
      // Construir mensaje de resultado
      const mensaje = `✅ ${exitososSentry} turnos de ${nombreVigilante} guardados exitosamente en Sentry para el año ${filtrosTurnos.año}. Fallidos: ${fallidosSentry}`;
      
      if (exitososSentry === 0) {
        setError(`❌ No se pudieron guardar turnos de ${nombreVigilante}. Errores: ${erroresUnicos.join(', ')}`);
      } else {
        setError(mensaje);
      }
      
    } catch (error) {
      console.error('❌ Error guardando turnos en Sentry:', error);
      setError(`Error guardando turnos en Sentry: ${error.message}`);
    }
  };

  const verificarTurnosGuardados = async (codPersona) => {
    if (!detallesServicio || !codPersona) return;

    try {
      console.log(`🔍 Verificando turnos guardados para persona ${codPersona}...`);
      
      const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
      const servicioIdToUse = Array.isArray(servicioId) ? servicioId[0] : servicioId;
      
      // Obtener el cuadranteId
      const userId = currentUser?.uid || 'system';
      const cuadranteId = await createCuadrante(servicioIdToUse, currentService, servicioIdToUse, userId);
      
      console.log('🔍 Verificando cuadrante ID:', cuadranteId);
      
      // Obtener todos los turnos del cuadrante
      const cuadranteRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId);
      const turnosSnapshot = await getDocs(collection(cuadranteRef, 'turnos'));
      
      console.log(`📊 Total de turnos encontrados en BD: ${turnosSnapshot.size}`);
      
      const turnosGuardados = [];
      turnosSnapshot.forEach(doc => {
        const turno = doc.data();
        turnosGuardados.push({
          id: doc.id,
          ...turno
        });
      });
      
      console.log('📋 Turnos guardados en BD:', turnosGuardados);
      
      // Filtrar turnos de la persona específica
      const turnosDePersona = turnosGuardados.filter(turno => 
        turno.vigilante === String(codPersona) || turno.codigoPersona === codPersona
      );
      
      console.log(`📊 Turnos de ${codPersona} en BD: ${turnosDePersona.length}`);
      console.log('📋 Turnos de la persona:', turnosDePersona);
      
      const vigilante = vigilantes.find(v => v.persona === codPersona);
      const nombreVigilante = vigilante ? `${vigilante.nombre} ${vigilante.apellidos}` : `persona ${codPersona}`;
      
      setError(`✅ Verificación completada: ${turnosDePersona.length} turnos de ${nombreVigilante} encontrados en BD. Revisa la consola para más detalles.`);
      
    } catch (error) {
      console.error('❌ Error verificando turnos guardados:', error);
      setError('Error verificando turnos guardados: ' + error.message);
    }
  };

  const probarPushFreematica = async (codPersona) => {
    if (!detallesServicio || !codPersona) return;

    try {
      console.log(`🧪 Probando push a Freematica para persona ${codPersona}...`);
      
      const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
      const empresa = datosLocalizacion.empresa || '0001';
      const delegacion = detallesServicio.delegacion || '06';
      let contrato = datosLocalizacion.contrato;
      const servicio = datosLocalizacion.servicio;

      // Verificar si el contrato es correcto
      const contratoCorrecto = '15241';
      if (contrato !== contratoCorrecto) {
        console.log('🔄 Usando contrato correcto para prueba...');
        contrato = contratoCorrecto;
      }

      // Obtener solo un turno para la prueba
      const turnos = await obtenerTurnosCuadrantesInteligente(
        empresa,
        delegacion,
        contrato,
        servicio,
        parseInt(filtrosTurnos.año),
        8, // Solo agosto para la prueba
        null,
        codPersona
      );

      if (!turnos || turnos.length === 0) {
        const vigilante = vigilantes.find(v => v.persona === codPersona);
        const nombreVigilante = vigilante ? `${vigilante.nombre} ${vigilante.apellidos}` : `persona ${codPersona}`;
        setError(`❌ No hay turnos para probar de ${nombreVigilante}`);
        return;
      }

      // Tomar solo el primer turno para la prueba
      const turnoPrueba = turnos[0];
      
      // Preparar el turno para la prueba
      const turnoData = {
        vigilante: String(turnoPrueba.codigoPersona),
        fecha: `${turnoPrueba.año}-${String(turnoPrueba.mes).padStart(2, '0')}-${String(turnoPrueba.dia).padStart(2, '0')}`,
        inicioTurno: turnoPrueba.horaInicio,
        finTurno: turnoPrueba.horaFin,
        horasTotales: turnoPrueba.horasTotales,
        empresa: turnoPrueba.empresa,
        delegacion: turnoPrueba.delegacion,
        contrato: turnoPrueba.contrato,
        servicio: turnoPrueba.servicio,
        turnoOper: turnoPrueba.turnoOper,
        nombrePersona: turnoPrueba.nombrePersona,
        apellido1: turnoPrueba.apellido1,
        apellido2: turnoPrueba.apellido2,
        nif: turnoPrueba.nif,
        origen: 'freematica',
        observaciones: 'Turno de prueba para Freematica',
        servicioId: Array.isArray(servicioId) ? servicioId[0] : servicioId
      };

      console.log('🧪 Turno de prueba:', turnoData);

      // Probar el push a Freematica
      const resultado = await pushTurnosAFreematica([turnoData], detallesServicio);
      
      const vigilante = vigilantes.find(v => v.persona === codPersona);
      const nombreVigilante = vigilante ? `${vigilante.nombre} ${vigilante.apellidos}` : `persona ${codPersona}`;
      
      if (resultado.success) {
        setError(`✅ Prueba de push a Freematica exitosa para ${nombreVigilante}. ${resultado.message}`);
      } else {
        setError(`❌ Error en prueba de push a Freematica para ${nombreVigilante}: ${resultado.error}`);
      }
      
    } catch (error) {
      console.error('❌ Error en prueba de push a Freematica:', error);
      setError(`Error en prueba de push a Freematica: ${error.message}`);
    }
  };

  const probarBusquedaServicio = async () => {
    if (!detallesServicio) return;

    try {
      console.log('🧪 Probando búsqueda de servicio en Freematica...');
      
      const datosLocalizacion = extraerDatosLocalizacion(detallesServicio.localizacion);
      const empresa = datosLocalizacion.empresa || '0001';
      const delegacion = detallesServicio.delegacion || '06';
      const contrato = datosLocalizacion.contrato;
      const servicio = datosLocalizacion.servicio;

      console.log('📋 Datos extraídos:', {
        empresa,
        delegacion,
        contrato,
        servicio
      });

      // Probar la búsqueda de servicio
      const servicioFreematica = await buscarServicioFreematica(empresa, delegacion, contrato, servicio);
      
      console.log('✅ Servicio encontrado:', servicioFreematica);
      
      setError(`✅ Servicio encontrado en Freematica: 
        Empresa: ${servicioFreematica.empresa}
        Delegación: ${servicioFreematica.delegacion}
        Contrato: ${servicioFreematica.contrato}
        Servicio: ${servicioFreematica.servicio}
        IDReg: ${servicioFreematica.idReg}
        ServiceTag: ${servicioFreematica.serviceTag}`);
      
    } catch (error) {
      console.error('❌ Error en prueba de búsqueda de servicio:', error);
      setError(`❌ Error en búsqueda de servicio: ${error.message}`);
    }
  };

  const toggleMes = (mes) => {
    setExpandedMeses(prev => ({
      ...prev,
      [mes]: !prev[mes]
    }));
  };

  const toggleDia = (mes, dia) => {
    const key = `${mes}-${dia}`;
    setExpandedDias(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleFiltroTurnosChange = (campo, valor) => {
    setFiltrosTurnos(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const formatearFechaCompleta = (año, mes, dia) => {
    try {
      const fecha = new Date(año, mes - 1, dia);
      return fecha.toLocaleDateString('es-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return `${año}-${mes}-${dia}`;
    }
  };

  const formatearHoras = (horas) => {
    if (!horas) return '0h';
    return `${parseFloat(horas).toFixed(1)}h`;
  };

  // Función para exportar datos
  const exportarDatos = () => {
    try {
      const datosExport = {
        fecha: new Date().toISOString(),
        servicio: detallesServicio?.nombreTienda || 'N/A',
        localizacion: detallesServicio?.localizacion || 'N/A',
        vigilantes: Object.entries(tramosData).map(([codPersona, data]) => ({
          codPersona,
          vigilante: data.vigilante,
          cuadrantes: data.cuadrantes
        }))
      };

      const blob = new Blob([JSON.stringify(datosExport, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cuadrantes_freematica_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exportando datos:', error);
      setError('Error exportando datos: ' + error.message);
    }
  };



  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" component="h1">
          📊 Cuadrantes de Freematica
        </Typography>
        <Box>
                      <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={obtenerCuadrantesFreematicaHandler}
              disabled={loading}
              sx={{ mr: 1 }}
            >
              {loading ? 'Obteniendo...' : 'Obtener Cuadrantes de Freematica'}
            </Button>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={exportarDatos}
            disabled={Object.keys(tramosData).length === 0}
            sx={{ mr: 1 }}
          >
            Exportar
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </Box>
      </Box>

      {/* Información del servicio */}
      {detallesServicio && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              📋 Información del Servicio
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <strong>Servicio:</strong> {detallesServicio.nombreTienda || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <strong>Localización:</strong> {detallesServicio.localizacion || 'N/A'}
                </Typography>
                {detallesServicio.localizacion && (
                  <Typography variant="caption" color="text.secondary">
                    Contrato: {extraerDatosLocalizacion(detallesServicio.localizacion).contrato} | 
                    Provincia: {detallesServicio.provincia || 'N/A'} | 
                    Delegación: {detallesServicio.delegacion || 'N/A'} | 
                    Empresa: {detallesServicio.empresa || 'N/A'} | 
                    Servicio: {extraerDatosLocalizacion(detallesServicio.localizacion).servicio}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <strong>Vigilantes:</strong> {vigilantes.length}
                </Typography>
              </Grid>
            </Grid>
            
            {/* Información de localización extraída */}
            {detallesServicio?.localizacion && (
              <Box sx={{ mt: 2, p: 2, bgcolor: 'yellow.50', borderRadius: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  <strong>Localización original:</strong> {detallesServicio.localizacion}
                </Typography>
                {(() => {
                  try {
                    const datos = extraerDatosLocalizacion(detallesServicio.localizacion);
                    return (
                      <>
                        <Typography variant="body2" color="text.secondary">
                          <strong>Contrato extraído:</strong> {datos.contrato}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <strong>Servicio extraído:</strong> {datos.servicio}
                        </Typography>
                      </>
                    );
                  } catch (error) {
                    return (
                      <Typography variant="body2" color="error">
                        <strong>Error extrayendo datos:</strong> {error.message}
                      </Typography>
                    );
                  }
                })()}
              </Box>
            )}
          </CardContent>
        </Card>
      )}

      {/* Configuración de la API */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            ⚙️ Configuración API Cuadrantes de Freematica
          </Typography>
          

          
          {/* Select de Empresas */}
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="empresa-select-label">Empresa</InputLabel>
            <Select
              labelId="empresa-select-label"
              value={empresaSeleccionada}
              onChange={handleEmpresaChange}
              size="small"
            >
              <MenuItem value="">
                <em>Seleccione una empresa</em>
              </MenuItem>
              {empresas.map((empresa) => (
                <MenuItem key={empresa.id} value={empresa.id}>
                  [{empresa.codEmpresa || 'N/A'}] {empresa.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Información de la empresa seleccionada */}
          {empresaSeleccionada && (
            <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
              <Typography variant="body2" color="text.secondary">
                <strong>Empresa para el endpoint:</strong> {empresas.find(emp => emp.id === empresaSeleccionada)?.nombre}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Código de empresa:</strong> {empresas.find(emp => emp.id === empresaSeleccionada)?.codEmpresa || 'N/A'}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Este código se usará para completar el endpoint de Freematica
              </Typography>
            </Box>
          )}

          {/* Select de Personas */}
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="persona-select-label">Persona</InputLabel>
            <Select
              labelId="persona-select-label"
              value={personaSeleccionada}
              onChange={handlePersonaChange}
              size="small"
            >
              <MenuItem value="">
                <em>Seleccione una persona (opcional - todas si no selecciona)</em>
              </MenuItem>
              {obtenerPersonasDisponibles().map((vigilante) => (
                <MenuItem key={vigilante.persona} value={vigilante.persona}>
                  [{vigilante.persona}] {vigilante.nombre} {vigilante.apellidos}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Información de personas disponibles */}
          {obtenerPersonasDisponibles().length > 0 && (
            <Box sx={{ mb: 2, p: 2, bgcolor: 'blue.50', borderRadius: 1 }}>
              <Typography variant="body2" color="text.secondary">
                <strong>Personas disponibles del servicio:</strong> {obtenerPersonasDisponibles().length}
              </Typography>
              {personaSeleccionada ? (
                <Typography variant="body2" color="text.secondary">
                  <strong>Persona seleccionada:</strong> {obtenerPersonasDisponibles().find(p => p.persona === personaSeleccionada)?.nombre} {obtenerPersonasDisponibles().find(p => p.persona === personaSeleccionada)?.apellidos}
                </Typography>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  <strong>Se consultarán todas las personas del servicio</strong>
                </Typography>
              )}
            </Box>
          )}

          {/* Mensaje si no hay personas en el servicio */}
          {obtenerPersonasDisponibles().length === 0 && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              No se encontraron personas con códigos válidos en el servicio. Verifique que los vigilantes tengan códigos de persona asignados.
            </Alert>
          )}

          {/* Botón para obtener cuadrantes */}
          <Button
            variant="contained"
            fullWidth
            onClick={obtenerCuadrantesFreematicaHandler}
            disabled={loading || !empresaSeleccionada || obtenerPersonasDisponibles().length === 0}
            sx={{ mt: 2 }}
          >
            {loading ? 'Obteniendo...' : 'Obtener Cuadrantes de Freematica'}
          </Button>
        </CardContent>
      </Card>



      {/* Mensajes de error */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* Indicador de carga */}
      {loading && (
        <Box display="flex" justifyContent="center" my={3}>
          <CircularProgress />
        </Box>
      )}

      {/* Resumen de datos */}
      {Object.keys(tramosData).length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              📈 Resumen de Cuadrantes de Freematica
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography variant="body2">
                  <strong>Vigilantes con cuadrantes:</strong> {Object.keys(tramosData).length}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="body2">
                  <strong>Año consultado:</strong> 
                  <Chip 
                    label={new Date().getFullYear().toString()} 
                    color="primary" 
                    size="small" 
                    sx={{ ml: 1 }}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="body2">
                  <strong>Servicio:</strong> {detallesServicio?.localizacion ? extraerDatosLocalizacion(detallesServicio.localizacion).servicio : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="body2">
                  <strong>Fecha consulta:</strong> {new Date().toLocaleDateString('es-ES')}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* Lista de vigilantes con cuadrantes */}
      {Object.keys(tramosData).length > 0 && (
        <div>
          <Typography variant="h6" gutterBottom>
            👥 Vigilantes y sus Cuadrantes de Freematica
          </Typography>
          
          {Object.entries(tramosData).map(([codPersona, data]) => (
            <Accordion 
              key={codPersona}
              expanded={expandedVigilante === codPersona}
              onChange={() => setExpandedVigilante(expandedVigilante === codPersona ? null : codPersona)}
              sx={{ mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center" width="100%">
                  <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
                    {data.vigilante.nombre} {data.vigilante.apellidos}
                  </Typography>
                  <Chip 
                    label="Cuadrante" 
                    color="primary" 
                    size="small"
                    sx={{ mr: 2 }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    Código: {codPersona}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" gutterBottom>
                      Información del Vigilante
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell><strong>Nombre:</strong></TableCell>
                            <TableCell>{data.vigilante.nombre} {data.vigilante.apellidos}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>Código:</strong></TableCell>
                            <TableCell>{codPersona}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>NIF:</strong></TableCell>
                            <TableCell>
                              {Object.values(data.cuadrantes)[0]?.VSSPER_NIF || 'N/A'}
                              {Object.values(data.cuadrantes)[0]?.VSSPER_NIF_DC || ''}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>Meses con cuadrantes:</strong></TableCell>
                            <TableCell>
                              {Object.keys(data.cuadrantes).length} mes(es)
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" gutterBottom>
                      Información del Servicio
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell><strong>Empresa:</strong></TableCell>
                            <TableCell>{Object.values(data.cuadrantes)[0]?.CUADT_EMP || 'N/A'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>Delegación:</strong></TableCell>
                            <TableCell>{Object.values(data.cuadrantes)[0]?.CUADT_DELEG || 'N/A'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>Contrato:</strong></TableCell>
                            <TableCell>{Object.values(data.cuadrantes)[0]?.CUADT_CTRT || 'N/A'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell><strong>Servicio:</strong></TableCell>
                            <TableCell>{Object.values(data.cuadrantes)[0]?.CUADT_SERV || 'N/A'}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      📅 Cuadrantes por Mes ({Object.keys(data.cuadrantes).length} meses)
                    </Typography>
                    
                    {Object.entries(data.cuadrantes).map(([mes, cuadrante]) => (
                      <Accordion key={mes} sx={{ mb: 1 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Box display="flex" alignItems="center" width="100%">
                            <Typography variant="subtitle2" sx={{ flexGrow: 1 }}>
                              Mes {mes} - {getMonthName(mes)}
                            </Typography>
                            <Chip 
                              label={`${cuadrante.CUADT_HHTOT}h totales`} 
                              color="primary" 
                              size="small"
                              sx={{ mr: 1 }}
                            />
                            <Chip 
                              label={`${cuadrante.CUADT_HHNOC}h nocturnas`} 
                              color="secondary" 
                              size="small"
                              sx={{ mr: 1 }}
                            />
                            <Chip 
                              label={`${cuadrante.CUADT_HHFEST}h festivas`} 
                              color="success" 
                              size="small"
                              sx={{ mr: 1 }}
                            />
                            <Button
                              size="small"
                              variant="outlined"
                              color="info"
                              onClick={(e) => {
                                e.stopPropagation();
                                cargarTurnosPorMes(codPersona, mes);
                              }}
                              disabled={cargandoTurnosIndividuales[`${codPersona}-${mes}`]}
                              sx={{ ml: 1 }}
                            >
                              {cargandoTurnosIndividuales[`${codPersona}-${mes}`] ? (
                                <>
                                  <CircularProgress size={16} sx={{ mr: 1 }} />
                                  Cargando Turnos...
                                </>
                              ) : (
                                '🎯 Turnos Individuales'
                              )}
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                guardarTurnosEnSentry(codPersona);
                              }}
                              sx={{ ml: 1 }}
                            >
                              💾 Guardar en Sentry
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="warning"
                              onClick={(e) => {
                                e.stopPropagation();
                                verificarTurnosGuardados(codPersona);
                              }}
                              sx={{ ml: 1 }}
                            >
                              ✅ Verificar Turnos Guardados
                            </Button>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Typography variant="subtitle2" gutterBottom>
                                Información del Mes {mes}
                              </Typography>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableBody>
                                    <TableRow>
                                      <TableCell><strong>Mes:</strong></TableCell>
                                      <TableCell>{mes} - {getMonthName(mes)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell><strong>Turno Operativo:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_TURNOPER}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell><strong>Cerrado:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_CERRADO || 'N/A'}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="subtitle2" gutterBottom>
                                Horas del Mes {mes}
                              </Typography>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableBody>
                                    <TableRow>
                                      <TableCell><strong>Horas Totales:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_HHTOT}h</TableCell>
                                      <TableCell><strong>Horas Totales B:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_HHTOTB}h</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell><strong>Horas Nocturnas:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_HHNOC}h</TableCell>
                                      <TableCell><strong>Horas Festivas:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_HHFEST}h</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell><strong>Horas Nocturnas Festivas:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_HHNOCP}h</TableCell>
                                      <TableCell><strong>Noches Festivas:</strong></TableCell>
                                      <TableCell>{cuadrante.CUADT_NOCFEST}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                            
                            {/* Sección de Turnos Individuales */}
                            <Grid item xs={12}>
                              <Box sx={{ mt: 2, p: 2, bgcolor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                                <Typography variant="h6" gutterBottom>
                                  🎯 Turnos Individuales - {data.vigilante.nombre} {data.vigilante.apellidos}
                                </Typography>
                                
                                {turnosPorMes[`${codPersona}-${mes}`] ? (
                                  <Box>
                                    <Typography variant="subtitle2" gutterBottom>
                                      📅 Turnos por Día ({Object.keys(turnosPorMes[`${codPersona}-${mes}`]).length} días)
                                    </Typography>
                                    
                                    {Object.entries(turnosPorMes[`${codPersona}-${mes}`]).map(([dia, turnos]) => (
                                      <Accordion key={dia} sx={{ mb: 1 }}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                          <Box display="flex" alignItems="center" width="100%">
                                            <Typography variant="subtitle2" sx={{ flexGrow: 1 }}>
                                              {formatearFechaCompleta(filtrosTurnos.año, mes, dia)}
                                            </Typography>
                                            <Chip 
                                              label={`${turnos.length} turnos`} 
                                              color="info" 
                                              size="small"
                                              sx={{ mr: 1 }}
                                            />
                                            <Chip 
                                              label={`${turnos.reduce((sum, t) => sum + (parseFloat(t.horasTotales) || 0), 0).toFixed(1)}h total`} 
                                              color="success" 
                                              size="small"
                                            />
                                          </Box>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <Grid container spacing={2}>
                                            {turnos.map((turno, index) => (
                                              <Grid item xs={12} md={6} lg={4} key={index}>
                                                <Card variant="outlined">
                                                  <CardContent>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                      Turno #{index + 1}
                                                    </Typography>
                                                    
                                                    <Box sx={{ mb: 1 }}>
                                                      <Typography variant="body2" color="text.secondary">
                                                        <strong>Horas Totales:</strong> {formatearHoras(turno.horasTotales)}
                                                      </Typography>
                                                      <Typography variant="body2" color="text.secondary">
                                                        <strong>Hora Inicio:</strong> 
                                                        <Chip 
                                                          label={turno.horaInicio || 'No calculada'} 
                                                          color={turno.horaInicio ? 'success' : 'error'} 
                                                          size="small" 
                                                          sx={{ ml: 1 }}
                                                        />
                                                      </Typography>
                                                      <Typography variant="body2" color="text.secondary">
                                                        <strong>Hora Fin:</strong> 
                                                        <Chip 
                                                          label={turno.horaFin || 'No calculada'} 
                                                          color={turno.horaFin ? 'success' : 'error'} 
                                                          size="small" 
                                                          sx={{ ml: 1 }}
                                                        />
                                                      </Typography>
                                                    </Box>
                                                    
                                                    <Box>
                                                      <Typography variant="body2" color="text.secondary">
                                                        <strong>Turno Operativo:</strong> {turno.turnoOper || 'N/A'}
                                                      </Typography>
                                                      <Typography variant="body2" color="text.secondary">
                                                        <strong>Empresa:</strong> {turno.empresa} | <strong>Delegación:</strong> {turno.delegacion}
                                                      </Typography>
                                                      <Typography variant="body2" color="text.secondary">
                                                        <strong>Contrato:</strong> {turno.contrato} | <strong>Servicio:</strong> {turno.servicio}
                                                      </Typography>
                                                    </Box>
                                                  </CardContent>
                                                </Card>
                                              </Grid>
                                            ))}
                                          </Grid>
                                        </AccordionDetails>
                                      </Accordion>
                                    ))}
                                  </Box>
                                ) : (
                                  <Box sx={{ textAlign: 'center', py: 2 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      Haz clic en "🎯 Turnos Individuales" para cargar los turnos detallados de este mes.
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      )}

      {/* Mensaje cuando no hay datos */}
      {!loading && Object.keys(tramosData).length === 0 && vigilantes.length > 0 && (
        <Card>
          <CardContent>
            <Typography variant="body1" textAlign="center" color="text.secondary">
              No se han obtenido cuadrantes aún. Haz clic en "Obtener Cuadrantes de Freematica" para cargar los datos desde Freematica.
            </Typography>
          </CardContent>
        </Card>
      )}

      {/* Mensaje cuando no hay vigilantes */}
      {!loading && vigilantes.length === 0 && (
        <Card>
          <CardContent>
            <Typography variant="body1" textAlign="center" color="text.secondary">
              No hay vigilantes asignados a este servicio.
            </Typography>
          </CardContent>
        </Card>
      )}


    </div>
  );
};

export default FreematicaTramos; 